export default Object.freeze({
    SLOT_NOT_AVAILABLE: 'SLOT_NOT_AVAILABLE',
    NOT_ACCPETING_INSURANCE: 'NOT_ACCPETING_INSURANCE',
    SERVICE_NOT_AVAILABLE: 'SERVICE_NOT_AVAILABLE',
    OTHER: 'OTHER',
    REFERRING_CANCELLED: 'REFERRING_CANCELLED',
    REFERRED_CANCELLED: 'REFERRED_CANCELLED',
    INSURANCE_AUTH_DENIED: 'INSURANCE_AUTH_DENIED',
    UNANSWERED: 'UNANSWERED',
})
